import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import Badge from '../../styled-components/components/Badge';
import Content from '../../styled-components/components/Content';
import Modal from '../../styled-components/components/Modal';

interface UspItemDemoCarModalProps {
  onClose: () => void;
}

const UspItemDemoCarModal = ({ onClose }: UspItemDemoCarModalProps) => {
  const { t } = useTranslation(['item']);

  return (
    <Modal heading={t('demoCar.heading', { ns: 'item' })} onClose={onClose}>
      <Content>
        <p>{t('demoCar.description', { ns: 'item' })}</p>
      </Content>
    </Modal>
  );
};

interface Props {
  title: React.ReactNode;
  icon: string;
  actionLabel?: string;
  isDemoVersion?: boolean;
}

const UspItem = ({ title, icon, isDemoVersion }: Props) => {
  const { t } = useTranslation(['item']);
  const [demoCarModal, setDemoCarModal] = useState(false);
  const onToggleDemoCarModal = useCallback(() => setDemoCarModal(!demoCarModal), [demoCarModal]);

  return (
    <div className="usp-grid-item">
      <div className="usp-grid-icon">
        <i className={`no-margin icon-${icon}`} />
      </div>
      <div className="usp-grid-label">{title}</div>
      {isDemoVersion && (
        <div className="usp-grid-meta">
          <Badge onInfo={onToggleDemoCarModal}>{t('demoCar.heading', { ns: 'item' })}</Badge>
        </div>
      )}
      {demoCarModal && <UspItemDemoCarModal onClose={onToggleDemoCarModal} />}
    </div>
  );
};

export default UspItem;
